module.exports = __webpack_public_path__ + "static/media/new_menu_logo.0e808aa9.png";